import { render, staticRenderFns } from "./SignatureDialogLayout.vue?vue&type=template&id=48b67ce4"
import script from "./SignatureDialogLayout.vue?vue&type=script&lang=js"
export * from "./SignatureDialogLayout.vue?vue&type=script&lang=js"
import style0 from "./SignatureDialogLayout.vue?vue&type=style&index=0&id=48b67ce4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports